import { useEffect, useState } from "react";
import { Pagination } from "./Pagination";

export function DataTable({ columns, data, pageSize = 5, disablePagination = false }) {
    const [currentPage, setCurrentPage] = useState(1);
    const totalPages = disablePagination ? 1 : Math.ceil(data.length / pageSize);

    // Reset or clamp page when data changes
    useEffect(() => {
        const newTotal = Math.max(1, Math.ceil(data.length / pageSize));
        if (currentPage > newTotal) {
            setCurrentPage(1);
        }
    }, [data, pageSize, currentPage]);

    // Get the data for the current page
    const paginatedData = disablePagination ? data : data.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    return (
        <div>
            <div className="table-responsive">
                <table className="table table-striped">
                    <thead>
                        <tr>
                            {columns.map((column, index) => (
                                <th key={index} scope="col">{column.Header}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                    {paginatedData.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {columns.map((column, colIndex) => (
                                <td key={colIndex}>
                                    {column.Cell ? column.Cell(row) : row[column.accessor]}
                                </td>
                            ))}
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            {!disablePagination && (
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={setCurrentPage}
                />
            )}
        </div>
    );
}
